module.exports = __webpack_public_path__ + "static/img/layout5.509850fe.png";